import React, { useState } from 'react';
import { Dropdown, Button, Modal, Form} from 'react-bootstrap';
import Visualizza_presenze_per_alunno from "./progetto_x2_presenze_lista_per_alunno.jsx";


 

const Progetto_controllo_presenze = (props) => {

    const [show_presenze, setShow_presenze] = useState(false);

    const handleClick = (event) => {
        console.log('entrato');
        setShow_presenze(true);
    }

    const handleClose = () => {
        setShow_presenze(false);
    }

    function invia_mail_di_inizio_stage() {
        console.log('invia_mail_di_inizio_stage');
    }

    const handleSubmit1 = (e) => {
        alert('scrivi qualcosa')
    }


   


   


    return (
        <div>
            <div>
                <Dropdown.Item onClick={handleClick} >Controllo Presenze</Dropdown.Item>
            </div>
            <div>
                <Modal
                    show={show_presenze}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Lista presenze</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="exampleForm.ControlTextarea1">

                                <Visualizza_presenze_per_alunno progetto={props.progetto} />

                            </Form.Group>
                        </Form>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleClose}>Chiudi</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    )
}
export default Progetto_controllo_presenze;